import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import Cards from '../../components/Cards/Cards';
import News from './news/news';

const CenteredSection = styled.div`
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  box-sizing: border-box;
  padding: 5px 0 0;
  background: #fff;

  & > * {
    max-width: 1600px;
    width: 100%;
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

const SectionContent = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`;

const NewsBlock = styled.div`
  width: 100%;
  max-height: calc(100vh - 80px);
  overflow: hidden;
  display: flex;
  justify-content: center;
`;

const Actions = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  padding-bottom: 8px;
`;

const Section5 = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <CenteredSection>
      <SectionContent>
        <NewsBlock>
          {isMobile ? <News /> : <Cards />}
        </NewsBlock>
        <Actions>
          <Link className="btn btn-outline-primary btn-sm" to="/noticias">
            Ver todas las noticias
          </Link>
        </Actions>
      </SectionContent>
    </CenteredSection>
  );
};

export default Section5;
